<div class="prompt-container" [class.kyc-mode]="isKycMode" [attr.data-variant]="isKycMode ? copy.variant : null">
  <ng-container *ngIf="isKycMode; else profileMode">
    <div class="prompt-icon">
      <mat-icon>{{ copy.iconName }}</mat-icon>
    </div>
    <h2>{{ copy.title }}</h2>
    <p>{{ copy.body }}</p>

    <ul class="prompt-steps" *ngIf="copy.showSteps">
      <li><mat-icon>edit_note</mat-icon><span>Fill organisation, banking & document details</span></li>
      <li><mat-icon>fact_check</mat-icon><span>Submit for review</span></li>
      <li><mat-icon>schedule</mat-icon><span>Admin approval — typically 2 to 3 business days</span></li>
    </ul>

    <div class="prompt-meta" *ngIf="kycReferenceNumber">
      Reference: <strong>{{ kycReferenceNumber }}</strong>
    </div>

    <div class="actions">
      <button mat-stroked-button (click)="later()">{{ copy.laterLabel }}</button>
      <button *ngIf="copy.ctaLabel" mat-flat-button color="accent" class="cta-orange" (click)="proceed()">{{ copy.ctaLabel }}</button>
    </div>
  </ng-container>

  <ng-template #profileMode>
    <h2>Complete your marketplace profile</h2>
    <p>
      Now that your KYC is verified, finish setting up your profile so buyers
      can discover you. We'll guide you through each step.
    </p>
    <div class="actions">
      <button mat-stroked-button color="primary" (click)="later()">Do it later</button>
      <button mat-flat-button color="accent" (click)="proceed()">Proceed with setup</button>
    </div>
  </ng-template>
</div>
